import { apiClient } from "./ApiConfig"

export const notificationApi = {
    getNotification: () => {
        return apiClient.get('/notification')
    },
    updateViewAll: () => {
        return apiClient.post('/notification/viewed_all')
    },
    updateClicked: (body: any) => {
        return apiClient.post('/notification/clicked', body)
    }
}